const links = [
    {social: 'https://www.facebook.com/cj.driz.dimla/', icon: 'facebook'},
    {social: 'https://www.instagram.com/cjdrizdimla/', icon: 'instagram'},
    {social: 'https://github.com/ChristianDriz', icon: 'github'},
    {social: 'https://www.linkedin.com/in/christian-joseph-dimla-921765294/', icon: 'linkedin'}
]

export default links;